import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import AttendanceForm from "./components/AttendanceForm";
import LeaveRequestForm from "./components/LeaveRequestForm";
import EmployeeDashboard from "./components/EmployeeDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import HolidayList from "./components/HolidayList";
import Sidebar from "./components/Sidebar";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import AdminAttendance from "./components/AdminAttendance";
import EmployeeAttendanceRecords from "./components/EmployeeAttendanceRecords";
import EmployeeDetails from "./components/EmployeeDetails";
import AdminAnnouncements from "./components/AdminAnnouncements";
import Employeetracker from "./components/Employeetracker";
import LeaveBalancePanel from "./components/LeaveBalancePanel";
import LandingPage from "./components/LandingPage";
import OrganizationRegister from "./components/OrganizationRegister";
function App() {
  return (
    <Router>
      <Routes>
         <Route path="/" element={<LandingPage />} />
        {/* Login page */}
        <Route path="/organization-register" element={<OrganizationRegister />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/login" element={<Login />} />

        {/* Employee dashboard (protected) */}
        <Route
          path="/employee"
          element={
            <ProtectedRoute role="employee">
              <EmployeeDashboard />
            </ProtectedRoute>
          }
        />
        {/* Employee Tracker (protected) */}
        <Route
          path="/employeetracker"
          element={
            <ProtectedRoute role="admin">
              <Employeetracker />
            </ProtectedRoute>
          }
        />
        {/* Leave Balance Panel (protected) */}
        <Route
          path="/leavebalance"
          element={
            <ProtectedRoute role="admin">
              <LeaveBalancePanel />
            </ProtectedRoute>
          }
        />

        {/* Admin Dashboard and all admin subpages */}
        <Route
          path="/admin-dashboard/*"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Other non-dashboard roles */}
        <Route
          path="/admin-attendance"
          element={
            <ProtectedRoute role="admin">
              <AdminAttendance />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-announcements"
          element={
            <ProtectedRoute role="admin">
              <AdminAnnouncements />
            </ProtectedRoute>
          }
        />

        {/* Employee Attendance */}
        <Route
          path="/my-attendance"
          element={
            <ProtectedRoute role="employee">
              <EmployeeAttendanceRecords />
            </ProtectedRoute>
          }
        />

        {/* Employee details (dynamic) */}
        <Route
          path="/employee/:id"
          element={
            <ProtectedRoute role="employee">
              <EmployeeDetails />
            </ProtectedRoute>
          }
        />

        {/* Attendance form */}
        <Route
          path="/attendance"
          element={
            <ProtectedRoute role="employee">
              <AttendanceForm />
            </ProtectedRoute>
          }
        />

        {/* Leave request form */}
        <Route
          path="/leave-request"
          element={
            <ProtectedRoute role="employee">
              <LeaveRequestForm />
            </ProtectedRoute>
          }
        />

        {/* Holidays list */}
        <Route
          path="/holidays"
          element={
            <ProtectedRoute role="employee">
              <HolidayList />
            </ProtectedRoute>
          }
        />

        {/* Sidebar route (dev testing) */}
        <Route
          path="/sidebar"
          element={
            <ProtectedRoute role="employee">
              <Sidebar />
            </ProtectedRoute>
          }
        />

        {/* Default route */}
        <Route
          path="/"
          element={
            localStorage.getItem("role") === "employee"
              ? <EmployeeDashboard />
              : <Login />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
